import type { Pinia } from 'pinia';
import { container } from '../di/Container';
import { PINIA_TOKEN } from '../di/tokens';

/**
 * Инстанс Pinia библиотеки. Регистрируется в DI-контейнере из `initLibrary()`,
 * поэтому на SSR каждый запрос получает свой (контейнер скоупится
 * `AsyncLocalStorage`) и состояние сторов не протекает между запросами.
 */
export function useTravelataPinia(): Pinia {
  return container.resolve(PINIA_TOKEN);
}
